{
  "defaultDate": "2026-08-07",
  "defaultTimeBlock": "13:00",
  "defaultView": "All PSS",
  "timeBlocks": ["00:00", "04:00", "08:00", "12:00", "13:00", "16:00", "20:00", "24:00"],
  "metrics": {
    "dsmExposureRs": 245780,
    "realTimeVisibilityPercent": 96.2,
    "curtailments": 2,
    "curtailmentMw": 58
  },
  "paymentSummaryYtd": [
    { "label": "Corpus Amount Paid", "amount": 21000000, "color": "#14a44d" },
    { "label": "Deviation Charges Paid", "amount": 4865210, "color": "#2563eb" },
    { "label": "LPS Charges Paid", "amount": 1000000, "color": "#f59e0b" },
    { "label": "Other Charges Paid", "amount": 1000000, "color": "#7c4ce0" }
  ],
  "scheduleAvcRows": [
    { "qcaCode": "QCA-001", "pssCode": "PSS-001", "requiredScheduleMw": 2200, "submittedScheduleMw": 2200, "pendingScheduleMw": 0, "schedulePercent": 100, "avcRequiredMw": 2150, "avcSubmittedMw": 2140, "avcPendingMw": 10, "avcPercent": 99.5, "actualInjectionMw": 2140, "lastSubmissionTime": "12:05", "status": "Submitted" },
    { "qcaCode": "QCA-002", "pssCode": "PSS-002", "requiredScheduleMw": 2450, "submittedScheduleMw": 2400, "pendingScheduleMw": 50, "schedulePercent": 97.9, "avcRequiredMw": 2400, "avcSubmittedMw": 2380, "avcPendingMw": 20, "avcPercent": 99.2, "actualInjectionMw": 2380, "lastSubmissionTime": "12:02", "status": "Submitted" },
    { "qcaCode": "QCA-003", "pssCode": "PSS-003", "requiredScheduleMw": 1246, "submittedScheduleMw": 1200, "pendingScheduleMw": 46, "schedulePercent": 96.3, "avcRequiredMw": 1210, "avcSubmittedMw": 1195, "avcPendingMw": 15, "avcPercent": 98.8, "actualInjectionMw": 1195, "lastSubmissionTime": "11:58", "status": "Pending" },
    { "qcaCode": "QCA-004", "pssCode": "PSS-004", "requiredScheduleMw": 1120, "submittedScheduleMw": 1080, "pendingScheduleMw": 40, "schedulePercent": 96.4, "avcRequiredMw": 1100, "avcSubmittedMw": 1060, "avcPendingMw": 40, "avcPercent": 96.4, "actualInjectionMw": 1027, "lastSubmissionTime": "11:55", "status": "Pending" }
  ],
"injectionSeries": [
  {"time":"00:00","scheduleMw":700,"revisedScheduleMw":700,"actualInjectionMw":620},
  {"time":"00:15","scheduleMw":700,"revisedScheduleMw":704,"actualInjectionMw":615},
  {"time":"00:30","scheduleMw":700,"revisedScheduleMw":709,"actualInjectionMw":608},
  {"time":"00:45","scheduleMw":700,"revisedScheduleMw":714,"actualInjectionMw":598},

  {"time":"01:00","scheduleMw":700,"revisedScheduleMw":725,"actualInjectionMw":486},
  {"time":"01:15","scheduleMw":700,"revisedScheduleMw":728,"actualInjectionMw":512},
  {"time":"01:30","scheduleMw":700,"revisedScheduleMw":731,"actualInjectionMw":548},
  {"time":"01:45","scheduleMw":700,"revisedScheduleMw":733,"actualInjectionMw":601},

  {"time":"02:00","scheduleMw":700,"revisedScheduleMw":735,"actualInjectionMw":655},
  {"time":"02:15","scheduleMw":700,"revisedScheduleMw":732,"actualInjectionMw":648},
  {"time":"02:30","scheduleMw":700,"revisedScheduleMw":730,"actualInjectionMw":652},
  {"time":"02:45","scheduleMw":700,"revisedScheduleMw":727,"actualInjectionMw":646},

  {"time":"03:00","scheduleMw":700,"revisedScheduleMw":724,"actualInjectionMw":644},
  {"time":"03:15","scheduleMw":700,"revisedScheduleMw":720,"actualInjectionMw":638},
  {"time":"03:30","scheduleMw":700,"revisedScheduleMw":718,"actualInjectionMw":632},
  {"time":"03:45","scheduleMw":700,"revisedScheduleMw":710,"actualInjectionMw":625},

  {"time":"04:00","scheduleMw":700,"revisedScheduleMw":698,"actualInjectionMw":539},
  {"time":"04:15","scheduleMw":700,"revisedScheduleMw":692,"actualInjectionMw":528},
  {"time":"04:30","scheduleMw":700,"revisedScheduleMw":687,"actualInjectionMw":521},
  {"time":"04:45","scheduleMw":700,"revisedScheduleMw":681,"actualInjectionMw":508},

  {"time":"05:00","scheduleMw":700,"revisedScheduleMw":674,"actualInjectionMw":466},
  {"time":"05:15","scheduleMw":850,"revisedScheduleMw":828,"actualInjectionMw":512},
  {"time":"05:30","scheduleMw":1050,"revisedScheduleMw":1028,"actualInjectionMw":591},
  {"time":"05:45","scheduleMw":1240,"revisedScheduleMw":1218,"actualInjectionMw":682},

  {"time":"06:00","scheduleMw":1423,"revisedScheduleMw":1388,"actualInjectionMw":1308},
  {"time":"06:15","scheduleMw":1635,"revisedScheduleMw":1608,"actualInjectionMw":1498},
  {"time":"06:30","scheduleMw":1848,"revisedScheduleMw":1824,"actualInjectionMw":1706},
  {"time":"06:45","scheduleMw":2340,"revisedScheduleMw":2318,"actualInjectionMw":2215},

  {"time":"07:00","scheduleMw":2828,"revisedScheduleMw":2806,"actualInjectionMw":2726},
  {"time":"07:15","scheduleMw":3150,"revisedScheduleMw":3136,"actualInjectionMw":3028},
  {"time":"07:30","scheduleMw":3480,"revisedScheduleMw":3462,"actualInjectionMw":3321},
  {"time":"07:45","scheduleMw":3795,"revisedScheduleMw":3788,"actualInjectionMw":3612},

  {"time":"08:00","scheduleMw":4108,"revisedScheduleMw":4112,"actualInjectionMw":3895},
  {"time":"08:15","scheduleMw":4380,"revisedScheduleMw":4392,"actualInjectionMw":4178},
  {"time":"08:30","scheduleMw":4655,"revisedScheduleMw":4671,"actualInjectionMw":4442},
  {"time":"08:45","scheduleMw":4925,"revisedScheduleMw":4950,"actualInjectionMw":4751},

  {"time":"09:00","scheduleMw":5191,"revisedScheduleMw":5219,"actualInjectionMw":5076},
  {"time":"09:15","scheduleMw":5398,"revisedScheduleMw":5422,"actualInjectionMw":5284},
  {"time":"09:30","scheduleMw":5605,"revisedScheduleMw":5638,"actualInjectionMw":5489},
  {"time":"09:45","scheduleMw":5810,"revisedScheduleMw":5842,"actualInjectionMw":5687},

  {"time":"10:00","scheduleMw":6013,"revisedScheduleMw":6048,"actualInjectionMw":5968},
  {"time":"10:15","scheduleMw":6145,"revisedScheduleMw":6171,"actualInjectionMw":6089},
  {"time":"10:30","scheduleMw":6278,"revisedScheduleMw":6301,"actualInjectionMw":6212},
  {"time":"10:45","scheduleMw":6402,"revisedScheduleMw":6425,"actualInjectionMw":6338},

  {"time":"11:00","scheduleMw":6526,"revisedScheduleMw":6546,"actualInjectionMw":6466},
  {"time":"11:15","scheduleMw":6570,"revisedScheduleMw":6582,"actualInjectionMw":6510},
  {"time":"11:30","scheduleMw":6615,"revisedScheduleMw":6628,"actualInjectionMw":6552},
  {"time":"11:45","scheduleMw":6658,"revisedScheduleMw":6669,"actualInjectionMw":6598},

  {"time":"12:00","scheduleMw":6700,"revisedScheduleMw":6694,"actualInjectionMw":6454},
  {"time":"12:15","scheduleMw":6658,"revisedScheduleMw":6651,"actualInjectionMw":6418},
  {"time":"12:30","scheduleMw":6615,"revisedScheduleMw":6608,"actualInjectionMw":6385},
  {"time":"12:45","scheduleMw":6570,"revisedScheduleMw":6561,"actualInjectionMw":6350},

  {"time":"13:00","scheduleMw":6526,"revisedScheduleMw":6497,"actualInjectionMw":6417},
  {"time":"13:15","scheduleMw":6398,"revisedScheduleMw":6372,"actualInjectionMw":6288},
  {"time":"13:30","scheduleMw":6270,"revisedScheduleMw":6248,"actualInjectionMw":6175},
  {"time":"13:45","scheduleMw":6142,"revisedScheduleMw":6118,"actualInjectionMw":6036},

  {"time":"14:00","scheduleMw":6013,"revisedScheduleMw":5979,"actualInjectionMw":5899},
  {"time":"14:15","scheduleMw":5808,"revisedScheduleMw":5784,"actualInjectionMw":5692},
  {"time":"14:30","scheduleMw":5600,"revisedScheduleMw":5578,"actualInjectionMw":5484},
  {"time":"14:45","scheduleMw":5395,"revisedScheduleMw":5372,"actualInjectionMw":5280},

  {"time":"15:00","scheduleMw":5191,"revisedScheduleMw":5172,"actualInjectionMw":5035},
  {"time":"15:15","scheduleMw":4920,"revisedScheduleMw":4908,"actualInjectionMw":4784},
  {"time":"15:30","scheduleMw":4650,"revisedScheduleMw":4642,"actualInjectionMw":4525},
  {"time":"15:45","scheduleMw":4380,"revisedScheduleMw":4372,"actualInjectionMw":4258},

  {"time":"16:00","scheduleMw":4108,"revisedScheduleMw":4116,"actualInjectionMw":3895},
  {"time":"16:15","scheduleMw":3790,"revisedScheduleMw":3798,"actualInjectionMw":3614},
  {"time":"16:30","scheduleMw":3475,"revisedScheduleMw":3486,"actualInjectionMw":3328},
  {"time":"16:45","scheduleMw":3150,"revisedScheduleMw":3162,"actualInjectionMw":3015},

  {"time":"17:00","scheduleMw":2828,"revisedScheduleMw":2858,"actualInjectionMw":2778},
  {"time":"17:15","scheduleMw":2475,"revisedScheduleMw":2501,"actualInjectionMw":2412},
  {"time":"17:30","scheduleMw":2125,"revisedScheduleMw":2150,"actualInjectionMw":2058},
  {"time":"17:45","scheduleMw":1775,"revisedScheduleMw":1802,"actualInjectionMw":1695},

  {"time":"18:00","scheduleMw":1423,"revisedScheduleMw":1457,"actualInjectionMw":1377},
  {"time":"18:15","scheduleMw":1242,"revisedScheduleMw":1271,"actualInjectionMw":1196},
  {"time":"18:30","scheduleMw":1060,"revisedScheduleMw":1091,"actualInjectionMw":1015},
  {"time":"18:45","scheduleMw":880,"revisedScheduleMw":908,"actualInjectionMw":841},

  {"time":"19:00","scheduleMw":700,"revisedScheduleMw":717,"actualInjectionMw":513},
  {"time":"19:15","scheduleMw":700,"revisedScheduleMw":712,"actualInjectionMw":508},
  {"time":"19:30","scheduleMw":700,"revisedScheduleMw":707,"actualInjectionMw":502},
  {"time":"19:45","scheduleMw":700,"revisedScheduleMw":702,"actualInjectionMw":496},

  {"time":"20:00","scheduleMw":700,"revisedScheduleMw":690,"actualInjectionMw":525},
  {"time":"20:15","scheduleMw":700,"revisedScheduleMw":686,"actualInjectionMw":532},
  {"time":"20:30","scheduleMw":700,"revisedScheduleMw":682,"actualInjectionMw":541},
  {"time":"20:45","scheduleMw":700,"revisedScheduleMw":677,"actualInjectionMw":550},

  {"time":"21:00","scheduleMw":700,"revisedScheduleMw":669,"actualInjectionMw":589},
  {"time":"21:15","scheduleMw":700,"revisedScheduleMw":667,"actualInjectionMw":581},
  {"time":"21:30","scheduleMw":700,"revisedScheduleMw":665,"actualInjectionMw":593},
  {"time":"21:45","scheduleMw":700,"revisedScheduleMw":668,"actualInjectionMw":596},

  {"time":"22:00","scheduleMw":700,"revisedScheduleMw":667,"actualInjectionMw":587},
  {"time":"22:15","scheduleMw":700,"revisedScheduleMw":672,"actualInjectionMw":579},
  {"time":"22:30","scheduleMw":700,"revisedScheduleMw":678,"actualInjectionMw":568},
  {"time":"22:45","scheduleMw":700,"revisedScheduleMw":682,"actualInjectionMw":556},

  {"time":"23:00","scheduleMw":700,"revisedScheduleMw":685,"actualInjectionMw":447},
  {"time":"23:15","scheduleMw":700,"revisedScheduleMw":689,"actualInjectionMw":438},
  {"time":"23:30","scheduleMw":700,"revisedScheduleMw":691,"actualInjectionMw":425},
  {"time":"23:45","scheduleMw":700,"revisedScheduleMw":694,"actualInjectionMw":412}
],
  "injectionBlockSeries": [
    {"time":"01","scheduleMw":700,"revisedScheduleMw":700,"actualInjectionMw":620},
    {"time":"02","scheduleMw":700,"revisedScheduleMw":707,"actualInjectionMw":561},
    {"time":"03","scheduleMw":700,"revisedScheduleMw":714,"actualInjectionMw":514},
    {"time":"04","scheduleMw":700,"revisedScheduleMw":720,"actualInjectionMw":487},
    {"time":"05","scheduleMw":700,"revisedScheduleMw":725,"actualInjectionMw":486},
    {"time":"06","scheduleMw":700,"revisedScheduleMw":729,"actualInjectionMw":513},
    {"time":"07","scheduleMw":700,"revisedScheduleMw":733,"actualInjectionMw":564},
    {"time":"08","scheduleMw":700,"revisedScheduleMw":734,"actualInjectionMw":627},
    {"time":"09","scheduleMw":700,"revisedScheduleMw":735,"actualInjectionMw":655},
    {"time":"10","scheduleMw":700,"revisedScheduleMw":734,"actualInjectionMw":654},
    {"time":"11","scheduleMw":700,"revisedScheduleMw":732,"actualInjectionMw":652},
    {"time":"12","scheduleMw":700,"revisedScheduleMw":728,"actualInjectionMw":648},
    {"time":"13","scheduleMw":700,"revisedScheduleMw":724,"actualInjectionMw":644},
    {"time":"14","scheduleMw":700,"revisedScheduleMw":718,"actualInjectionMw":638},
    {"time":"15","scheduleMw":700,"revisedScheduleMw":712,"actualInjectionMw":632},
    {"time":"16","scheduleMw":700,"revisedScheduleMw":705,"actualInjectionMw":610},
    {"time":"17","scheduleMw":700,"revisedScheduleMw":698,"actualInjectionMw":539},
    {"time":"18","scheduleMw":700,"revisedScheduleMw":691,"actualInjectionMw":482},
    {"time":"19","scheduleMw":700,"revisedScheduleMw":685,"actualInjectionMw":448},
    {"time":"20","scheduleMw":700,"revisedScheduleMw":679,"actualInjectionMw":443},
    {"time":"21","scheduleMw":700,"revisedScheduleMw":674,"actualInjectionMw":466},
    {"time":"22","scheduleMw":700,"revisedScheduleMw":669,"actualInjectionMw":512},
    {"time":"23","scheduleMw":700,"revisedScheduleMw":667,"actualInjectionMw":575},
    {"time":"24","scheduleMw":1062,"revisedScheduleMw":1027,"actualInjectionMw":947},
    {"time":"25","scheduleMw":1423,"revisedScheduleMw":1388,"actualInjectionMw":1308},
    {"time":"26","scheduleMw":1782,"revisedScheduleMw":1748,"actualInjectionMw":1668},
    {"time":"27","scheduleMw":2136,"revisedScheduleMw":2105,"actualInjectionMw":2025},
    {"time":"28","scheduleMw":2485,"revisedScheduleMw":2458,"actualInjectionMw":2378},
    {"time":"29","scheduleMw":2828,"revisedScheduleMw":2806,"actualInjectionMw":2726},
    {"time":"30","scheduleMw":3162,"revisedScheduleMw":3146,"actualInjectionMw":3066},
    {"time":"31","scheduleMw":3488,"revisedScheduleMw":3478,"actualInjectionMw":3369},
    {"time":"32","scheduleMw":3804,"revisedScheduleMw":3801,"actualInjectionMw":3630},
    {"time":"33","scheduleMw":4108,"revisedScheduleMw":4112,"actualInjectionMw":3895},
    {"time":"34","scheduleMw":4400,"revisedScheduleMw":4411,"actualInjectionMw":4172},
    {"time":"35","scheduleMw":4679,"revisedScheduleMw":4696,"actualInjectionMw":4464},
    {"time":"36","scheduleMw":4943,"revisedScheduleMw":4966,"actualInjectionMw":4768},
    {"time":"37","scheduleMw":5191,"revisedScheduleMw":5219,"actualInjectionMw":5076},
    {"time":"38","scheduleMw":5423,"revisedScheduleMw":5454,"actualInjectionMw":5374},
    {"time":"39","scheduleMw":5638,"revisedScheduleMw":5672,"actualInjectionMw":5592},
    {"time":"40","scheduleMw":5835,"revisedScheduleMw":5870,"actualInjectionMw":5790},
    {"time":"41","scheduleMw":6013,"revisedScheduleMw":6048,"actualInjectionMw":5968},
    {"time":"42","scheduleMw":6171,"revisedScheduleMw":6204,"actualInjectionMw":6124},
    {"time":"43","scheduleMw":6310,"revisedScheduleMw":6340,"actualInjectionMw":6260},
    {"time":"44","scheduleMw":6428,"revisedScheduleMw":6454,"actualInjectionMw":6374},
    {"time":"45","scheduleMw":6526,"revisedScheduleMw":6546,"actualInjectionMw":6466},
    {"time":"46","scheduleMw":6602,"revisedScheduleMw":6616,"actualInjectionMw":6492},
    {"time":"47","scheduleMw":6656,"revisedScheduleMw":6664,"actualInjectionMw":6481},
    {"time":"48","scheduleMw":6689,"revisedScheduleMw":6690,"actualInjectionMw":6466},
    {"time":"49","scheduleMw":6700,"revisedScheduleMw":6694,"actualInjectionMw":6454},
    {"time":"50","scheduleMw":6689,"revisedScheduleMw":6676,"actualInjectionMw":6449},
    {"time":"51","scheduleMw":6656,"revisedScheduleMw":6637,"actualInjectionMw":6449},
    {"time":"52","scheduleMw":6602,"revisedScheduleMw":6578,"actualInjectionMw":6448},
    {"time":"53","scheduleMw":6526,"revisedScheduleMw":6497,"actualInjectionMw":6417},
    {"time":"54","scheduleMw":6428,"revisedScheduleMw":6396,"actualInjectionMw":6316},
    {"time":"55","scheduleMw":6310,"revisedScheduleMw":6276,"actualInjectionMw":6196},
    {"time":"56","scheduleMw":6171,"revisedScheduleMw":6136,"actualInjectionMw":6056},
    {"time":"57","scheduleMw":6013,"revisedScheduleMw":5979,"actualInjectionMw":5899},
    {"time":"58","scheduleMw":5835,"revisedScheduleMw":5803,"actualInjectionMw":5723},
    {"time":"59","scheduleMw":5638,"revisedScheduleMw":5609,"actualInjectionMw":5529},
    {"time":"60","scheduleMw":5423,"revisedScheduleMw":5399,"actualInjectionMw":5319},
    {"time":"61","scheduleMw":5191,"revisedScheduleMw":5172,"actualInjectionMw":5035},
    {"time":"62","scheduleMw":4943,"revisedScheduleMw":4930,"actualInjectionMw":4736},
    {"time":"63","scheduleMw":4679,"revisedScheduleMw":4673,"actualInjectionMw":4443},
    {"time":"64","scheduleMw":4400,"revisedScheduleMw":4401,"actualInjectionMw":4161},
    {"time":"65","scheduleMw":4108,"revisedScheduleMw":4116,"actualInjectionMw":3895},
    {"time":"66","scheduleMw":3804,"revisedScheduleMw":3819,"actualInjectionMw":3642},
    {"time":"67","scheduleMw":3488,"revisedScheduleMw":3509,"actualInjectionMw":3393},
    {"time":"68","scheduleMw":3162,"revisedScheduleMw":3188,"actualInjectionMw":3108},
    {"time":"69","scheduleMw":2828,"revisedScheduleMw":2858,"actualInjectionMw":2778},
    {"time":"70","scheduleMw":2485,"revisedScheduleMw":2518,"actualInjectionMw":2438},
    {"time":"71","scheduleMw":2136,"revisedScheduleMw":2171,"actualInjectionMw":2091},
    {"time":"72","scheduleMw":1782,"revisedScheduleMw":1817,"actualInjectionMw":1737},
    {"time":"73","scheduleMw":1423,"revisedScheduleMw":1457,"actualInjectionMw":1377},
    {"time":"74","scheduleMw":1062,"revisedScheduleMw":1093,"actualInjectionMw":1013},
    {"time":"75","scheduleMw":700,"revisedScheduleMw":728,"actualInjectionMw":643},
    {"time":"76","scheduleMw":700,"revisedScheduleMw":723,"actualInjectionMw":572},
    {"time":"77","scheduleMw":700,"revisedScheduleMw":717,"actualInjectionMw":513},
    {"time":"78","scheduleMw":700,"revisedScheduleMw":711,"actualInjectionMw":476},
    {"time":"79","scheduleMw":700,"revisedScheduleMw":704,"actualInjectionMw":466},
    {"time":"80","scheduleMw":700,"revisedScheduleMw":697,"actualInjectionMw":484},
    {"time":"81","scheduleMw":700,"revisedScheduleMw":690,"actualInjectionMw":525},
    {"time":"82","scheduleMw":700,"revisedScheduleMw":683,"actualInjectionMw":582},
    {"time":"83","scheduleMw":700,"revisedScheduleMw":678,"actualInjectionMw":598},
    {"time":"84","scheduleMw":700,"revisedScheduleMw":673,"actualInjectionMw":593},
    {"time":"85","scheduleMw":700,"revisedScheduleMw":669,"actualInjectionMw":589},
    {"time":"86","scheduleMw":700,"revisedScheduleMw":666,"actualInjectionMw":586},
    {"time":"87","scheduleMw":700,"revisedScheduleMw":665,"actualInjectionMw":585},
    {"time":"88","scheduleMw":700,"revisedScheduleMw":665,"actualInjectionMw":585},
    {"time":"89","scheduleMw":700,"revisedScheduleMw":667,"actualInjectionMw":587},
    {"time":"90","scheduleMw":700,"revisedScheduleMw":670,"actualInjectionMw":570},
    {"time":"91","scheduleMw":700,"revisedScheduleMw":674,"actualInjectionMw":510},
    {"time":"92","scheduleMw":700,"revisedScheduleMw":679,"actualInjectionMw":466},
    {"time":"93","scheduleMw":700,"revisedScheduleMw":685,"actualInjectionMw":447},
    {"time":"94","scheduleMw":700,"revisedScheduleMw":691,"actualInjectionMw":456},
    {"time":"95","scheduleMw":700,"revisedScheduleMw":698,"actualInjectionMw":494},
    {"time":"96","scheduleMw":700,"revisedScheduleMw":705,"actualInjectionMw":553}
  ],
"revisionRows": [
  {
    "id": "REV-001",
    "pssCode": "PSS-001",
    "revisionType": "Intraday Revision",
    "timeBlock": "49 (12:00 - 12:15)",
    "submittedAt": "11-08-2026 12:05",
    "submittedBy": "DemoUser-1",
    "scheduleMw": 240,
    "scheduleChangeMw": 32,
    "scheduleChangePercent": 15.38,
    "avcMw": 225,
    "avcChangeMw": 25,
    "avcChangePercent": 12.5,
    "status": "Approved"
  },
  {
    "id": "REV-002",
    "pssCode": "PSS-002",
    "revisionType": "Intraday Revision",
    "timeBlock": "48 (11:45 - 12:00)",
    "submittedAt": "11-08-2026 11:50",
    "submittedBy": "DemoUser-2",
    "scheduleMw": 208,
    "scheduleChangeMw": -32,
    "scheduleChangePercent": -13.33,
    "avcMw": 198,
    "avcChangeMw": -30,
    "avcChangePercent": -13.16,
    "status": "Approved"
  },
  {
    "id": "REV-003",
    "pssCode": "PSS-003",
    "revisionType": "Day Ahead Revision",
    "timeBlock": "-",
    "submittedAt": "11-08-2026 10:10",
    "submittedBy": "DemoUser-3",
    "scheduleMw": 365,
    "scheduleChangeMw": 65,
    "scheduleChangePercent": 21.67,
    "avcMw": 350,
    "avcChangeMw": 60,
    "avcChangePercent": 20.69,
    "status": "Approved"
  },
  {
    "id": "REV-004",
    "pssCode": "PSS-004",
    "revisionType": "Week Ahead Revision",
    "timeBlock": "-",
    "submittedAt": "10-08-2026 16:40",
    "submittedBy": "DemoUser-1",
    "scheduleMw": 580,
    "scheduleChangeMw": -120,
    "scheduleChangePercent": -17.14,
    "avcMw": 545,
    "avcChangeMw": -110,
    "avcChangePercent": -16.79,
    "status": "Approved"
  },
  {
    "id": "REV-005",
    "pssCode": "PSS-002",
    "revisionType": "Day Ahead Revision",
    "timeBlock": "-",
    "submittedAt": "10-08-2026 15:20",
    "submittedBy": "DemoUser-4",
    "scheduleMw": 420,
    "scheduleChangeMw": 85,
    "scheduleChangePercent": 25.37,
    "avcMw": 400,
    "avcChangeMw": 80,
    "avcChangePercent": 25,
    "status": "Approved"
  },
  {
    "id": "REV-006",
    "pssCode": "PSS-005",
    "revisionType": "Intraday Revision",
    "timeBlock": "46 (11:15 - 11:30)",
    "submittedAt": "11-08-2026 11:22",
    "submittedBy": "DemoUser-5",
    "scheduleMw": 198,
    "scheduleChangeMw": 18,
    "scheduleChangePercent": 10,
    "avcMw": 185,
    "avcChangeMw": 15,
    "avcChangePercent": 8.82,
    "status": "Approved"
  },
  {
    "id": "REV-007",
    "pssCode": "PSS-006",
    "revisionType": "Intraday Revision",
    "timeBlock": "45 (11:00 - 11:15)",
    "submittedAt": "11-08-2026 11:08",
    "submittedBy": "DemoUser-1",
    "scheduleMw": 276,
    "scheduleChangeMw": -44,
    "scheduleChangePercent": -13.75,
    "avcMw": 260,
    "avcChangeMw": -40,
    "avcChangePercent": -13.33,
    "status": "Approved"
  },
  {
    "id": "REV-008",
    "pssCode": "PSS-007",
    "revisionType": "Day Ahead Revision",
    "timeBlock": "-",
    "submittedAt": "11-08-2026 09:45",
    "submittedBy": "DemoUser-1",
    "scheduleMw": 354,
    "scheduleChangeMw": 54,
    "scheduleChangePercent": 18,
    "avcMw": 330,
    "avcChangeMw": 48,
    "avcChangePercent": 17.02,
    "status": "Approved"
  },
  {
    "id": "REV-009",
    "pssCode": "PSS-008",
    "revisionType": "Week Ahead Revision",
    "timeBlock": "-",
    "submittedAt": "10-08-2026 14:10",
    "submittedBy": "DemoUser-1",
    "scheduleMw": 424,
    "scheduleChangeMw": -76,
    "scheduleChangePercent": -15.2,
    "avcMw": 410,
    "avcChangeMw": -70,
    "avcChangePercent": -14.58,
    "status": "Approved"
  },
  {
    "id": "REV-010",
    "pssCode": "PSS-009",
    "revisionType": "Intraday Revision",
    "timeBlock": "42 (10:15 - 10:30)",
    "submittedAt": "11-08-2026 10:18",
    "submittedBy": "DemoUser-2",
    "scheduleMw": 267,
    "scheduleChangeMw": 27,
    "scheduleChangePercent": 11.25,
    "avcMw": 252,
    "avcChangeMw": 22,
    "avcChangePercent": 9.57,
    "status": "Approved"
  },
  {
    "id": "REV-011",
    "pssCode": "PSS-009",
    "revisionType": "Intraday Revision",
    "timeBlock": "41 (10:15 - 10:30)",
    "submittedAt": "11-08-2026 10:18",
    "submittedBy": "DemoUser-2",
    "scheduleMw": 294,
    "scheduleChangeMw": 27,
    "scheduleChangePercent": 10.11,
    "avcMw": 274,
    "avcChangeMw": 22,
    "avcChangePercent": 8.73,
    "status": "Approved"
  }

],

"alerts": [
  { "level": "critical", "title": "Deviation limit exceeded at PSS-102", "detail": "Deviation -2.61% is more than 2%", "dateTime": "13-08-2026 12:59" },
  { "level": "warning", "title": "1 Generator is on Outage", "detail": "Total 48 MW capacity affected", "dateTime": "13-08-2026 12:45" },
  { "level": "warning", "title": "SCADA data delayed for 5 minutes", "detail": "PSS-101 (Inverter-12, Inverter-18)", "dateTime": "13-08-2026 12:40" },
  { "level": "success", "title": "Intraday Revision-2 submitted", "detail": "By PSS-205 at 12:20 IST", "dateTime": "13-08-2026 12:20" },
  { "level": "success", "title": "Day Ahead schedule approved", "detail": "By SLDC at 10:30 IST", "dateTime": "13-08-2026 10:31" },
  { "level": "info", "title": "PSS-006 schedule received", "detail": "Schedule submitted for the next time block", "dateTime": "13-08-2026 10:20" },
  { "level": "warning", "title": "AvC pending for PSS-003", "detail": "46 MW schedule records need review", "dateTime": "13-08-2026 10:10" },
  { "level": "success", "title": "SCADA connection restored", "detail": "PSS-008 telemetry is reporting normally", "dateTime": "13-08-2026 09:56" },
  { "level": "info", "title": "Day-ahead window opened", "detail": "Submissions are available until 11:00 IST", "dateTime": "13-08-2026 09:30" },
  { "level": "critical", "title": "Low injection detected at PSS-004", "detail": "Actual injection is 6.6% below revised schedule", "dateTime": "13-08-2026 09:15" },

  { "level": "critical", "title": "Communication lost at PSS-117", "detail": "No telemetry data received for 12 minutes", "dateTime": "13-08-2026 09:05" },
  { "level": "warning", "title": "Schedule deviation approaching limit", "detail": "PSS-204 deviation is currently -1.82%", "dateTime": "13-08-2026 08:55" },
  { "level": "info", "title": "Intraday Revision-1 received", "detail": "Revision submitted by PSS-014 for the next block", "dateTime": "13-08-2026 08:45" },
  { "level": "success", "title": "Generator restored at PSS-009", "detail": "24 MW generation capacity is back online", "dateTime": "13-08-2026 08:38" },
  { "level": "warning", "title": "Generator outage reported", "detail": "Generator GEN-034 at PSS-112 is unavailable", "dateTime": "13-08-2026 08:30" },
  { "level": "info", "title": "Forecast data updated", "detail": "Solar forecast refreshed for all mapped PSS", "dateTime": "13-08-2026 08:20" },
  { "level": "success", "title": "PSS-021 schedule accepted", "detail": "Day-ahead schedule successfully validated", "dateTime": "13-08-2026 08:12" },
  { "level": "warning", "title": "AVC limit mismatch detected", "detail": "Configured AVC differs from submitted schedule at PSS-018", "dateTime": "13-08-2026 08:05" },
  { "level": "critical", "title": "Injection dropped at PSS-031", "detail": "Actual generation is 8.4% below expected output", "dateTime": "13-08-2026 07:58" },
  { "level": "info", "title": "New PSS mapping completed", "detail": "PSS-221 successfully mapped to QCA-08", "dateTime": "13-08-2026 07:45" },

  { "level": "success", "title": "Day-ahead schedule submitted", "detail": "All 116 mapped PSS schedules received", "dateTime": "13-08-2026 07:35" },
  { "level": "warning", "title": "Partial schedule received", "detail": "PSS-045 has submitted only 18 of 24 time blocks", "dateTime": "13-08-2026 07:25" },
  { "level": "info", "title": "Market schedule window opened", "detail": "QCA submissions are now available", "dateTime": "13-08-2026 07:15" },
  { "level": "critical", "title": "Multiple generators unavailable", "detail": "3 generators at PSS-078 are affecting 96 MW capacity", "dateTime": "13-08-2026 07:05" },
  { "level": "success", "title": "Telemetry synchronization completed", "detail": "All PSS telemetry timestamps synchronized successfully", "dateTime": "13-08-2026 06:58" },
  { "level": "warning", "title": "PSS-054 telemetry unstable", "detail": "Intermittent SCADA packets detected in the last 10 minutes", "dateTime": "13-08-2026 06:50" },
  { "level": "info", "title": "Forecast revision available", "detail": "Updated renewable generation forecast is ready for review", "dateTime": "13-08-2026 06:40" },
  { "level": "success", "title": "QCA-12 registration approved", "detail": "Registration approval completed by administrator", "dateTime": "13-08-2026 06:30" },
  { "level": "warning", "title": "Pending approval for QCA-16", "detail": "Registration documents are awaiting administrator review", "dateTime": "13-08-2026 06:20" },
  { "level": "critical", "title": "Severe deviation at PSS-089", "detail": "Deviation of -3.42% exceeds the permitted threshold", "dateTime": "13-08-2026 06:10" },

  { "level": "info", "title": "Daily schedule processing started", "detail": "System has started processing today's schedules", "dateTime": "13-08-2026 06:00" },
  { "level": "success", "title": "Daily data validation completed", "detail": "All received schedules passed basic validation", "dateTime": "13-08-2026 05:52" },
  { "level": "warning", "title": "Missing generation data", "detail": "PSS-063 has not reported generation data for 8 minutes", "dateTime": "13-08-2026 05:45" },
  { "level": "info", "title": "System maintenance completed", "detail": "Scheduled maintenance completed successfully", "dateTime": "13-08-2026 05:30" }
],
  "unitScheduleRows": [
    { "pssCode": "PSS-001", "companyName": "SunGreen Pvt Ltd", "unitName": "Solar Plant-01", "technology": "Solar", "installedCapacityMw": 100, "scheduleMw": 85, "revisedMw": 87, "actualMw": 84, "deviationMw": -1, "deviationPercent": -1.16, "lastRevision": "12:05" },
    { "pssCode": "PSS-001", "companyName": "SunGreen Pvt Ltd", "unitName": "Solar Plant-02", "technology": "Solar", "installedCapacityMw": 75, "scheduleMw": 65, "revisedMw": 63, "actualMw": 61, "deviationMw": -2, "deviationPercent": -3.17, "lastRevision": "12:05" },
    { "pssCode": "PSS-001", "companyName": "Bright Solar Ltd", "unitName": "Solar Plant-03", "technology": "Solar", "installedCapacityMw": 120, "scheduleMw": 105, "revisedMw": 103, "actualMw": 106, "deviationMw": 1, "deviationPercent": 0.94, "lastRevision": "12:05" },
    { "pssCode": "PSS-001", "companyName": "Bright Solar Ltd", "unitName": "Solar Plant-04", "technology": "Solar", "installedCapacityMw": 80, "scheduleMw": 70, "revisedMw": 72, "actualMw": 69, "deviationMw": -1, "deviationPercent": -1.43, "lastRevision": "12:05" }
  ]
}
